import { getSearchResultsRoute } from '@/api/toya/apiConstantsCodespot'
import { postWithAuth } from '@/api/httpRequests'
import { searchQueryLimit } from '@/shared/constants/appConstants'

export const useSearchResultsToya = () => {
    const getSearchResults = async (query: string) => {
        const requestBody = JSON.stringify({ query, limit: searchQueryLimit })
        return await postWithAuth(getSearchResultsRoute, true, requestBody)
    }

    return { getSearchResults }
}
